import { Identity, IPage } from "@amzn/ask-legal-domain";

export interface PageLiveDisplay {
    displayDate: Date;
    authorIdentity?: Identity;
}

/**
 * Selects the date/author for the live page's "Updated on" line: prefer the publish record
 * (publishedBy/publishedDate from load2), else fall back to the page's last-modified.
 * freshnessDate is deliberately not used: it moves when the page is baselined, which is a
 * review, not a content update.
 */
export function selectPageLiveDisplay(output: IPage.LoadPageOutput): PageLiveDisplay {
    const displayDate = output.publishedDate ?? output.page.lastModifiedDate;
    const authorIdentity = output.publishedBy ?? output.page.lastModifiedBy;
    return { displayDate, authorIdentity };
}
